export const MESSAGE_TYPES = {
  announcement: 'ANNOUNCEMENT',
  upcomingDate: 'UPCOMING_DATE',
};
